module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - Articulações'
    }
  }), _vm._v(" "), _c('div', [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Parcerias Estratégicas")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Cadastro',
        href: '#'
      }, {
        text: 'Parcerias Estratégicas',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "listaArticulacoes"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Lista de Instituições "), (!_vm.loading.tela) ? _c('span', {
    staticClass: "info_discreto"
  }, [_vm._v(_vm._s(_vm.tabelaArticulacao.totalRows) + " localizado(s)")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'edita-articulacao',
          params: {
            id: null
          }
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Nova Instituição ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa),
      expression: "pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa..."
    },
    domProps: {
      "value": (_vm.pesquisa)
    },
    on: {
      "keyup": _vm.ajustaPesquisa,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pesquisa = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "disabled": !_vm.tabelaArticulacao.filter,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.tabelaArticulacao.filter = ''
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 text-right"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "success",
      "size": "button--size-ss",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.exportarExcel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Exportar Excel ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row box-body"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "hover": "",
      "bordered": _vm.tabelaArticulacao.bordered,
      "items": _vm.articulacoes,
      "fields": _vm.camposArticulacao,
      "filter": _vm.tabelaArticulacao.filter,
      "filter-function": _vm.filtroPorItem,
      "current-page": _vm.tabelaArticulacao.currentPage,
      "per-page": _vm.tabelaArticulacao.perPage,
      "sort-by": _vm.tabelaArticulacao.sortBy,
      "sort-desc": _vm.tabelaArticulacao.sortDesc,
      "empty-filtered-text": "Nada foi encontrado. Refaça sua pesquisa!",
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "filtered": _vm.onFiltered,
      "update:sortBy": function($event) {
        return _vm.$set(_vm.tabelaArticulacao, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.tabelaArticulacao, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.tabelaArticulacao, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.tabelaArticulacao, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "id",
      fn: function(row) {
        return [_vm._v("\n                      " + _vm._s(row.value) + "\n                    ")]
      }
    }, {
      key: "nome",
      fn: function(row) {
        return [_vm._v("\n                        " + _vm._s(row.item.dados.nome) + "\n                    ")]
      }
    }, {
      key: "alertas",
      fn: function(row) {
        return [(row.value.instrumetosVencer.length === 0 && row.value.instrumentosVencidos.length === 0) ? _c('div', {
          staticClass: "text-muted"
        }, [_vm._v("Sem alertas")]) : _c('div', [(row.value.instrumetosVencer.length > 0) ? _c('div', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
          }],
          staticClass: "label label-warning",
          attrs: {
            "title": '<h5>Vecimentos em (dias):<li>' + _vm._.join(_vm._.sortBy(_vm._.map(row.value.instrumetosVencer, 'dias')), '<li>') + '</h5>'
          }
        }, [_vm._v("\n                          " + _vm._s(row.value.instrumetosVencer.length) + " à vencer\n                        ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(" ")]), _vm._v(" "), (row.value.instrumentosVencidos.length > 0) ? _c('div', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
          }],
          staticClass: "label label-danger",
          attrs: {
            "title": '<h5>Vecidos a (dias):<li>' + _vm._.join(_vm._.sortBy(_vm._.map(row.value.instrumentosVencidos, 'dias')), '<li>') + '</h5>'
          }
        }, [_vm._v("\n                          " + _vm._s(row.value.instrumentosVencidos.length) + " vencido " + _vm._s(row.value.instrumentosVencidos.length > 1 ? 's' : '') + "\n                        ")]) : _vm._e()])]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [_c('g-button-ujarak', {
          attrs: {
            "color": "primary",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'edita-articulacao',
                params: {
                  id: row.item.id
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil",
          attrs: {
            "aria-label": "false"
          }
        }), _vm._v(" Editar")]), _vm._v(" "), _c('g-button-ujarak', {
          attrs: {
            "color": "success",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'edita-articulacao',
                params: {
                  id: row.item.id,
                  visualizacao: true
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-search",
          attrs: {
            "aria-label": "false"
          }
        }), _vm._v(" Visualizar")])]
      }
    }])
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.tabelaArticulacao.totalRows,
      "per-page": _vm.tabelaArticulacao.perPage
    },
    model: {
      value: (_vm.tabelaArticulacao.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.tabelaArticulacao, "currentPage", $$v)
      },
      expression: "tabelaArticulacao.currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])], 1)])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-28303e22!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/articulacao/ListaArticulacoes.vue
// module id = 1893
// module chunks = 1